import LicenseStatusAction from "../../formability/licenseBuilder/models/licensing/licenseStatusAction";
import Guid from "../helpers/guid";
import {Month} from "../enums/month";
import {DurationUnit} from "../enums/durationUnit";
import {DatetimeComparison} from "./conditionalRules/datetimeComparison";
import {StatusActivationEventType} from "../enums/statusActivationType";
import IRepo from "../interfaces/repo";
import Repo from "../state/modules/repo";
import Vue from "vue";
import BuilderModel from "./tracked/builderModel";
import ObjectModelAction from "./objectModelActions/objectModelAction";
import LicenseLinkedForm from "../../formability/licenseBuilder/models/licensing/licenseLinkedForm";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import {DurationType} from "~/enums/durationType";
import BaseObjectModelEntry from "~/models/objectModelEntries/baseObjectModelEntry";
import {ObjectModelBuiltinPropertyType} from "~/enums/objectModelBuiltinPropertyType";
import {windowComparisonType} from "~/enums/windowComparisonType";
import FormDetailObjectModelPrerequisite from "../../formability/form_builder/models/formDetails/formDetailObjectModelPrerequisite";
import {FormulaContext} from "~/formulaContext";
import {Evaluator, Value, dateFromValue} from "formula-engine";

export default class RelativeTimePeriod extends BuilderModel {
  type: number;
  day: number;
  month: number;
  amount: number;
  unit: number;
  text: string;
  comparison: DatetimeComparison;
  event: StatusActivationEventType;
  datetime: string;
  property_client_id: string;
  derived_value: string;
  derived_value_formula: string;
  builtin_property_type: ObjectModelBuiltinPropertyType;
  window_comparison_type: windowComparisonType
  except = ['fieldName'];

  static repo: IRepo<RelativeTimePeriod> = new Repo<RelativeTimePeriod>('relativeTimePeriods', RelativeTimePeriod);

  constructor(parent: LicenseStatusAction | ObjectModelAction | LicenseLinkedForm | ObjectModelTrigger | FormDetailObjectModelPrerequisite, private fieldName: string, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('type', null);
    this.defineProperty('day', 31);
    this.defineProperty('month', Month.december);
    this.defineProperty('amount', 0);
    this.defineProperty('unit', DurationUnit.day);
    this.defineProperty('text', '');
    this.defineProperty('comparison', DatetimeComparison.isBefore);
    this.defineProperty('event', StatusActivationEventType.dateOfAward);
    this.defineProperty("derived_value", null);
    this.defineProperty("derived_value_formula", null);
    this.defineProperty("datetime", null);
    this.defineProperty("property_client_id", null);
    this.defineProperty("builtin_property_type", null);
    this.defineProperty("window_comparison_type", windowComparisonType.Starting);

    this.fieldName = fieldName;
    this.parent = parent;
    this.rootModel = parent.rootModel;

    this.loadFromJson(json, this.rootModel);

    RelativeTimePeriod.repo.add(this);
    Vue.set(parent, fieldName, this);
  }

  get rootName(): string {
    return this.fieldName;
  }

  get isCollectionRoot(): boolean {
    return false;
  }

  isBefore(other: Date, entry: BaseObjectModelEntry): boolean {
    switch (this.type) {
      case DurationType.never:
        return true;
      case DurationType.fixedDate:
        const date = new Date((new Date()).getFullYear(), this.month, this.day);
        return date.getTime() <= other.getTime();
      case DurationType.customFormula:
        const lookup = (name: string): Value | null => {
          const val = entry[name.replace(/f_([a-z0-9]{8})([a-z0-9]{4})([a-z0-9]{4})([a-z0-9]{4})([a-z0-9]{12})/, 'f_$1-$2-$3-$4-$5')];
          return Value.fromJSValue(val);
        };
        const evaluator = new Evaluator(new FormulaContext(lookup));
        const result = evaluator.evaluate(this.derived_value_formula);
        return dateFromValue(result).valueOf() <= other.getTime();
      default:
        return false
    }
  }

  isAfter(other: Date, entry: BaseObjectModelEntry): boolean {
    switch (this.type) {
      case DurationType.never:
        return true;
      case DurationType.fixedDate:
        const date = new Date((new Date()).getFullYear(), this.month, this.day);
        return date.getTime() >= other.getTime();
      case DurationType.customFormula:
        const lookup = (name: string): Value | null => {
          const val = entry[name.replace(/f_([a-z0-9]{8})([a-z0-9]{4})([a-z0-9]{4})([a-z0-9]{4})([a-z0-9]{12})/, 'f_$1-$2-$3-$4-$5')];
          return Value.fromJSValue(val);
        };
        const evaluator = new Evaluator(new FormulaContext(lookup));
        const result = evaluator.evaluate(this.derived_value_formula);
        return dateFromValue(result).valueOf() >= other.getTime();
      default:
        return false
    }
  }
}